import { FormatPrice } from '@/components/blocks/HDMPriceDisplay/FormatPrice';
import {
	promoGeneralSX,
	promoIconSX,
	separatorSx,
	typoSX,
} from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import {
	PRODUCT_CARD_PROMO_ICONS_IMG_URL,
	PROMOTION_TYPES,
} from '@/data/constants/promoIconConstants';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import { Box, CardMedia, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext } from 'react';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

export const WholeSalePrice = ({ wholeSalePrice }: any) => {
	const { selection, product: parentProduct } = useContext(ContentContext) as ReturnType<
		typeof useProductDetails
	> &
		ReturnType<typeof useSkuListTable>;
	const { JustBy, PerPiece, PerPieceWhenBuying, Pieces, OrMore } =
		useLocalization('WholeSalePrice');
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	if (wholeSalePrice === null) return null; // Now the hooks are called before this conditional return

	const product = selection?.sku ? selection?.sku : parentProduct;
	const { offer } = product?.productPrice || {};
	const [quantity, discount] = wholeSalePrice?.longDesc?.split('||') || [];
	const discountPercent = parseFloat(discount) || 0;
	const promoPrice = offer ? offer * (1 - discountPercent / 100) : null;
	const ICON_URL = `${CDN_BASE_URL}/${PRODUCT_CARD_PROMO_ICONS_IMG_URL.PROMORIBBON_AHP}`;

	return (
		<Box>
			<Divider sx={separatorSx} />
			<Box>
				<Box sx={promoGeneralSX.promoiconContainer} id={PROMOTION_TYPES.PROMORIBBON_AHP}>
					<CardMedia
						image={ICON_URL}
						sx={promoIconSX.ahp}
						title={PROMOTION_TYPES.PROMORIBBON_AHP}
						component="img"
						className={setClassName(PROMOTION_TYPES.PROMORIBBON_AHP)}
					/>
					<Box>
						<Typography variant="body1" component={isMobile ? 'p' : 'span'} sx={typoSX.firstRow}>
							{JustBy.t()} <FormatPrice price={promoPrice!} type="simple" /> {PerPiece.t()}{' '}
						</Typography>
						<Typography variant="body1" component={'span'}>
							<Typography variant="body2" component={'span'}>
								{PerPieceWhenBuying.t()}{' '}
							</Typography>
							<Typography variant="body2" component="span" sx={typoSX.firstRow}>
								{quantity} {Pieces.t()}{' '}
							</Typography>
							<Typography variant="body2" component="span">
								{OrMore.t()}
								<sup>†</sup>
							</Typography>
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
